import { v } from 'convex/values';

export const SCAN_RUN_STATUS_VALIDATOR = v.union(
  v.literal('queued'),
  v.literal('running'),
  v.literal('deferred'),
  v.literal('succeeded'),
  v.literal('failed'),
);

export const SCAN_RUN_PHASE_VALIDATOR = v.union(
  v.literal('access'),
  v.literal('tree'),
  v.literal('extracting'),
  v.literal('tokens'),
  v.literal('hardcoded'),
  v.literal('dropped'),
  v.literal('rejected-export'),
  v.literal('ingest'),
  v.literal('done'),
);

export const SCAN_RUN_PROFILE_VALIDATOR = v.union(
  v.literal('full'),
  v.literal('onboarding'),
);

export const SCAN_RUN_CACHE_MODE_VALIDATOR = v.union(
  v.literal('reuse'),
  v.literal('force'),
  v.literal('skip'),
);

export const SCAN_RUN_TRIGGERED_BY_VALIDATOR = v.union(
  v.literal('user'),
  v.literal('onboarding'),
  v.literal('onboarding-followup'),
  v.literal('manual-rescan'),
  v.literal('webhook'),
);

export type ScanRunTriggeredBy =
  | 'user'
  | 'onboarding'
  | 'onboarding-followup'
  | 'manual-rescan'
  | 'webhook';

export const SCAN_RUN_ACTIVE_STATUSES = new Set([
  'queued',
  'running',
  'deferred',
]);

export function isActiveScanRunStatus(status: string) {
  return SCAN_RUN_ACTIVE_STATUSES.has(status);
}

export type ScanRunPhase =
  | 'access'
  | 'tree'
  | 'extracting'
  | 'tokens'
  | 'hardcoded'
  | 'dropped'
  | 'rejected-export'
  | 'ingest'
  | 'done';

export interface ScanRunProgressInput {
  phase?: ScanRunPhase;
  filesProcessed?: number;
  totalFiles?: number;
  componentsFound?: number;
  tokensFound?: number;
  hardcodedFound?: number;
  latestComponent?: string;
}

export function toScanRunProgressPatch(progress: ScanRunProgressInput) {
  return {
    ...(progress.phase !== undefined ? { phase: progress.phase } : {}),
    ...(progress.filesProcessed !== undefined
      ? { filesProcessed: progress.filesProcessed }
      : {}),
    ...(progress.totalFiles !== undefined
      ? { totalFiles: progress.totalFiles }
      : {}),
    ...(progress.componentsFound !== undefined
      ? { componentsFound: progress.componentsFound }
      : {}),
    ...(progress.tokensFound !== undefined
      ? { tokensFound: progress.tokensFound }
      : {}),
    ...(progress.hardcodedFound !== undefined
      ? { hardcodedFound: progress.hardcodedFound }
      : {}),
    ...(progress.latestComponent !== undefined
      ? { latestComponent: progress.latestComponent }
      : {}),
  };
}
